import type { MutableRefObject } from 'react'

/**
 * Maybe it's a React ref, or a dom node.
 *
 * ```ts
 * type MaybeRef<T> = T | MutableRefObject<T>
 * ```
 */
export type MaybeRef<T> = T | MutableRefObject<T>

/**
 * Check if object is a React ref
 */
export const isRef = (obj: unknown): boolean =>
	obj !== null &&
	typeof obj === 'object' &&
	Object.prototype.hasOwnProperty.call(obj, 'current');

/**
 * Accepts either a ref object or a dom node and returns a dom node
 * @param target - ref or a dom node
 * @returns dom noe
 */
export function unRef<T = HTMLElement>(target: MaybeRef<T>): T {
	return isRef(target)
		? (target as MutableRefObject<T>).current
		: (target as T);
}
